import { render, staticRenderFns } from "./CustomFieldLabel.vue?vue&type=template&id=7965b03e&"
import script from "./CustomFieldLabel.vue?vue&type=script&lang=ts&"
export * from "./CustomFieldLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7965b03e')) {
      api.createRecord('7965b03e', component.options)
    } else {
      api.reload('7965b03e', component.options)
    }
    module.hot.accept("./CustomFieldLabel.vue?vue&type=template&id=7965b03e&", function () {
      api.rerender('7965b03e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_CustomFields/CustomFieldLabel.vue"
export default component.exports